import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Stack,

} from "@mui/material";
import {
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SyncLoader
} from "react-spinners"


const loaders = [
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SyncLoader
]

const loaderNames = {
  'BarLoader': { height: 4, width: 100 },
  'BeatLoader': { size: 15, margin: 2 },
  'BounceLoader': { size: 60 },
  'CircleLoader': { size: 50 },
  'ClimbingBoxLoader': { size: 15 },
  'ClipLoader': { size: 35 },
  'ClockLoader': { size: 50 },
  'DotLoader': { size: 60, margin: 2 },
  'FadeLoader': { height: 15, width: 5, radius: 2, margin: 2 },
  'GridLoader': { size: 15, margin: 2 },
  'HashLoader': { size: 50, margin: 2 },
  'MoonLoader': { size: 60, margin: 2 },
  'PacmanLoader': { size: 25, margin: 2 },
  'PropagateLoader': { size: 15 },
  'PuffLoader': { size: 60 },
  'PulseLoader': { size: 15, margin: 2 },
  'RingLoader': { size: 60, margin: 2 },
  'RiseLoader': { size: 15, margin: 2 },
  'RotateLoader': { size: 15, margin: 2 },
  'ScaleLoader': { height: 35, width: 4, radius: 2, margin: 2 },
  'SyncLoader': { size: 15, margin: 2 },
}

const loaderOptions = Object.keys(loaderNames).map((d, i) => {
  return {
    name: d, component: loaders[i],
    sx: loaderNames[d]
  }
});

function Loader() {
  const theme = useTheme();

  const [selectedLoader, setSelectedLoader] = useState(localStorage.getItem('themeLoader') || "CircleLoader");
  const SelectedLoader = loaderOptions.find(l => l.name === selectedLoader).component;

  return (
    <Stack
      direction='row'
      sx={{
        height: "90vh"
      }}
    >
      <Stack

        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: "100%"


        }}
      >
        <SelectedLoader
          color={theme.palette.primary.main}

        />
      </Stack>
    </Stack>

  );
}

export default Loader;
